// ブランドごとの法務文書。
//
// ■ 方針
// 利用規約・個人情報保護方針は**事業者ごとに別物**。運営主体もドメインも
// 違うので文面は共有しない。片方の事情で直した文面が、もう片方の会員にも
// 出てしまうため。
//
// ■ 増やし方
// 1. src/client/legal/<id>/ に .tsx を置く
// 2. 下の分岐に 1 本足す
//
// ■ なぜ Record ではなく分岐で書くか
// `import.meta.env.VITE_BRAND_ID` はビルド時に文字列リテラルへ置換されるため、
// 分岐で書くと**選ばれなかったブランドの本文は成果物に入らない**。
// Record に並べると全ブランドの文面がどのビルドにも入り、CFL の配信物に
// オフレコの条文が含まれる状態になる。
//
// ■ 文書を持たないブランド
// null を返す。ルートもフッタのリンクも出ないので、**今までと同じ**。
// CFL は自前の文書が用意できた時点で分岐を足す。
import { lazy, type LazyExoticComponent, type ComponentType } from "react";

const BRAND_ID = import.meta.env.VITE_BRAND_ID;

type Doc = LazyExoticComponent<ComponentType> | null;

export const privacyDoc: Doc =
  BRAND_ID === "ofreco"
    ? lazy(() =>
        import("./ofreco/Privacy").then((m) => ({ default: m.PrivacyPage })),
      )
    : null;
